import {useEffect} from 'react';
import {createCounter} from 'shared/utils/counter';
import {roundDecimal} from 'shared/utils/number';

const sizeCounter = createCounter({
  initial: 1,
  step: 0.05,
});

export function adjustFontSize(outerNode: HTMLElement, innerNode: HTMLElement): void {
  if (!innerNode || !outerNode) return;

  outerNode.removeAttribute('style');
  sizeCounter.reset();

  while (innerNode.offsetWidth >= outerNode.offsetWidth) {
    const newValue = sizeCounter.decrease();
    const fontSize = roundDecimal(newValue, 3);
    outerNode.style.fontSize = `${fontSize}em`;

    if (fontSize <= 0.1) break;
  }
}

export function useFontSizeAdjust(wrapper: HTMLElement, text: HTMLElement): void {
  useEffect(() => adjustFontSize(wrapper, text));
}
